import { Form } from 'react-bootstrap';

const CurrencyDecimal = ({
  value,
  label,
  name,
  onChange,
  className,
  labelClassName,
  inputClassName,
  placeholder,
}) => {
  const handleChange = (e) => {
    const eTmp = { ...e };
    if (Number(e.target.value) < 0) {
      e.target.value = '0';
    }
    if (e.target.value.length === 1) {
      eTmp.value = `0${e.target.value}`;
    } else {
      eTmp.value = e.target.value;
    }
    onChange(eTmp);
  };

  return (
    <div className={className}>
      {label && <Form.Label className={labelClassName}>{label}</Form.Label>}
      <div className="d-flex align-items-center">
        <h5 className="mb-0 me-8">.</h5>
        <div>
          <Form.Control
            name={name}
            type="number"
            value={value}
            id="inputCurrencyDecimal"
            className={inputClassName}
            onChange={handleChange}
            placeholder={placeholder}
          />
        </div>
      </div>
    </div>
  );
};

export default CurrencyDecimal;
